<template>
  <div :id="baseDivId + '-container'">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'GPDraggable',
  components: {},
  data() {
    return {
      positions: [0,0,0,0,0], //first element ignored to keep 1,2,3,4
      element: null,
      headerElement: null
    }
  },
  props: {
    baseDivId: {
      type: String,
      default: "gp-draggable"
    },
  },
  mounted() {
    this.element = document.getElementById(this.baseDivId + "-container")
    this.headerElement = document.getElementById(this.baseDivId + "-header")

    if (this.element) {
      this.element.classList.add("gp-draggable-container")
      if (this.headerElement) this.headerElement.classList.add("gp-draggable-header")
      this.dragElement()

    }
    else console.error("GP Draggable called without the right elements in place.")
  },
  methods: {
    dragElement() {
      if (this.headerElement) {
        // if present, the header is where you move the DIV from:
        this.headerElement.onmousedown = this.dragMouseDown;
      } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        this.element.onmousedown = this.dragMouseDown;
      }
    },

    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.positions[3] = e.clientX;
      this.positions[4] = e.clientY;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      this.positions[1] = this.positions[3]- e.clientX;
      this.positions[2] = this.positions[4] - e.clientY;
      this.positions[3] = e.clientX;
      this.positions[4] = e.clientY;
      // set the element's new position:
      this.element.style.top = (this.element.offsetTop - this.positions[2]) + "px";
      this.element.style.left = (this.element.offsetLeft - this.positions[1]) + "px";
    },

    closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    }

  }

}
;
</script>
<style scoped>
.gp-draggable-container {
  position: absolute;
  z-index: 1000;
}

.gp-draggable-header {
  cursor: move;
  z-index: 10;
}
</style>
